const angular = require('angular')
// 加载Loading控件
// usage: $loading.show(); $loading.hide();

angular.module('ui.hxphone.loading', [])

  .directive('loading', [function () {
    return {
      restrict: 'EA',
      template: require('views/components/loading.html'),
      replace: true
    }
  }])

  .provider('$loading', function () {
    return {
      $get: ['$transition', '$compile', '$rootScope', '$$uiHelpers', '$translate', '$ionicLoading',
        function ($transition, $compile, $rootScope, $$uiHelpers, $translate, $ionicLoading) {
          const $loading = {}

          $loading.show = function (text) {
            const loadingTips = text || '{{"TIPS.LOADING" | translate}}'
            $ionicLoading.show({
              template: '<ion-spinner></ion-spinner> <div class="text">' + loadingTips + '</div>'
            }).then(function () {
            })
            return true
          }

          $loading.hide = function () {
            $ionicLoading.hide().then(function () {
            })
            return true
          }
          return $loading
        }]
    }
  })



// WEBPACK FOOTER //
// ./src/js/infrastructure/loading.js